/**
 * EmptyState Component
 *
 * Friendly empty state with icon, title, description, and optional action.
 *
 * @package PresszoneComments
 */

import { el } from '../utils/dom.js';

/**
 * Render a friendly empty state.
 *
 * @param {string} icon - Large emoji
 * @param {string} title - Empty state title
 * @param {string} description - Helpful description
 * @param {HTMLElement} action - Optional action button
 * @param {string} variant - Optional variant ('default' | 'welcome')
 */
export function EmptyState(icon, title, description, action = null, variant = 'default') {
    const className = variant === 'welcome' 
        ? 'presszone-comments-empty-state presszone-comments-empty-state--welcome' 
        : 'presszone-comments-empty-state';

    return el('div', { class: className },
        el('div', { class: 'presszone-comments-empty-state__icon' }, icon),
        el('h3', { class: 'presszone-comments-empty-state__title' }, title),
        el('p', { class: 'presszone-comments-empty-state__desc' }, description),
        action ? el('div', { class: 'presszone-comments-empty-state__action' }, action) : null
    );
}

export default EmptyState;
